import React, { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'
import { useRecoilValue } from 'recoil'

import { modalBeeContentDialogState } from '../recoil/state'

import styled from '@emotion/styled'

const TRANSITION_CN = 'c-slider-container-transition'
const TRANSITION_NEXT_CN = 'c-slider-container-transition--next'
const TRANSITION_PREV_CN = 'c-slider-container-transition--prev'

const WizardOuter = styled.div`
  overflow: hidden;
`

const WizardContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;

  &.${TRANSITION_CN} {
    pointer-events: none;
    transition: transform 0.3s ease-in-out;
    transform: translateX(0);
  }

  &.${TRANSITION_NEXT_CN} {
    transform: translateX(-100%) !important;
  }

  &.${TRANSITION_PREV_CN} {
    transform: translateX(100%) !important;
  }
`

const StyledPanel = styled.section`
  width: 100%;
  flex-shrink: 0;
  position: relative;
`

export const Wizard = ({ steps, children }) => {
  const containerEl = useRef(null)
  const { step } = useRecoilValue(modalBeeContentDialogState)
  const prevStep = useRef()

  const onTransitioned = () => {
    containerEl.current.classList.remove(
      TRANSITION_CN,
      TRANSITION_NEXT_CN,
      TRANSITION_PREV_CN
    )

    const els = containerEl.current.childNodes
    els.forEach((item, index) => {
      const diff = index + 1 - prevStep.current
      const order = diff >= 0 ? diff + 1 : diff + steps.length + 1

      if (parseInt(item.style.order) !== order) {
        item.style.order = order
        if (order !== 1) {
          item.style.display = 'none'
        }
      }
    })
  }

  useEffect(() => {
    const els = containerEl.current.childNodes
    els.forEach((item, index) => {
      item.style.order = index + 1
      if (index > 0) {
        item.style.display = 'none'
      }
    })

    prevStep.current = step
    containerEl.current.addEventListener('transitionend', onTransitioned)

    return () => {
      if (containerEl.current) {
        containerEl.current.removeEventListener('transitioned', onTransitioned)
      }
    }
  }, [])

  useEffect(() => {
    if (prevStep.current !== step) {
      const movingNext = step > prevStep.current

      const els = containerEl.current.childNodes
      els.forEach((item, index) => {
        item.style.display = 'initial'
      })

      containerEl.current.classList.add(
        TRANSITION_CN,
        movingNext ? TRANSITION_NEXT_CN : TRANSITION_PREV_CN
      )
      prevStep.current = step
    }
  }, [step])

  return (
    <WizardOuter>
      <WizardContainer ref={containerEl}>{children}</WizardContainer>
    </WizardOuter>
  )
}

export const Panel = ({ children }) => {
  return <StyledPanel>{children}</StyledPanel>
}

Wizard.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.number),
  children: PropTypes.node
}

Panel.propTypes = {
  children: PropTypes.node
}
